import { useEffect, useState } from "react";
import { getHeaderStats } from "../service";
import { SvgCamera, SvgPosition, SvgCreditLeft } from "ui/svgs";

export default function HeaderStat() {
  const [headerStats, setHeaderStats] = useState(null);
  useEffect(() => {
    getHeaderStats().then((data) => {
      if (data.status === 200) {
        setHeaderStats(data.data.stats);
      }
    });
  }, []);
  return (
    <div style={{ flex: "1" }}>
      <div
        style={{
          width: "fit-content",
          height: "40px",
          display: "flex",
          alignItems: "center",
          marginLeft: "16px",
          backgroundColor: "white",
          padding: "9px 16px",
          borderRadius: "12px",
        }}
      >
        <SvgPosition width="12" />
        <span style={{ marginLeft: "4px" }}>{headerStats?.siteNum || "-"}</span>
        <div
          style={{
            height: "16px",
            width: "1px",
            borderRight: "1px solid rgba(225, 225, 225, 1)",
            marginLeft: "8px",
          }}
        />
        <SvgCamera width="16" className="ml-[8px]" />
        <span style={{ marginLeft: "4px", color: "rgba(25, 168, 124, 1)" }}>
          {headerStats?.onlineCamNum ?? "-"}
        </span>
        <span style={{ marginLeft: "4px" }}>/</span>
        <span style={{ marginLeft: "4px", color: "rgba(242, 43, 28, 1)" }}>
          {headerStats?.offlineCamNum ?? "-"}
        </span>

        <div
          style={{
            height: "16px",
            width: "1px",
            borderRight: "1px solid rgba(225, 225, 225, 1)",
            marginLeft: "8px",
          }}
        />
        <SvgCreditLeft width="16" className="fill-[#222222] ml-1" />
        <span className="">
          {headerStats?.remainingCredits?.toLocaleString() || "-"}
        </span>
      </div>
    </div>
  );
}
